import React from "react";
import { TrendingUp } from "lucide-react";


const RecommendationCard = ({ recommendation, theme, darkMode }) => (
  <div
    className={`border-2 rounded-lg p-4 ${
      recommendation.priority === "high"
        ? "border-red-200 bg-red-50"
        : recommendation.priority === "medium"
        ? "border-yellow-200 bg-yellow-50"
        : "border-blue-200 bg-blue-50"
    }`}
  >
    <div className="flex items-start space-x-3">
      <TrendingUp className="h-5 w-5 text-blue-600 mt-0.5" />
      <div className="flex-1">
        <p
          className={`${
            darkMode ? "text-black" : "text-gray-900"
          } font-medium mb-1`}
        >
          {recommendation.text}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600">
            Target: {recommendation.target_criterion}
          </span>
          <span
            className={`text-xs px-2 py-1 rounded-full font-medium ${
              recommendation.priority === "high"
                ? "bg-red-100 text-red-800"
                : recommendation.priority === "medium"
                ? "bg-yellow-100 text-yellow-800"
                : "bg-blue-100 text-blue-800"
            }`}
          >
            {recommendation.priority} priority
          </span>
        </div>
      </div>
    </div>
  </div>
);


export default RecommendationCard;